import { render, staticRenderFns } from "./get-started.vue?vue&type=template&id=58ff1b34&scoped=true&"
import script from "./get-started.vue?vue&type=script&lang=js&"
export * from "./get-started.vue?vue&type=script&lang=js&"
import style0 from "./get-started.vue?vue&type=style&index=0&id=58ff1b34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ff1b34",
  null
  
)

export default component.exports